export const wsocket = {
  io: false,
  screenShareRtcPeer: null,
  audioOrVideoRtcPeer: [],
  snapshotRtcPeer: null,
  audioAndVideoRtcPeer: [],/* To Store audio and video rtcpeer separatly eg ["participant_id_1":{audio: rtcpeer, video:rtcpeer}, "participant_id_2":{audio: rtcpeer, video:rtcpeer}]*/
  videoTimer: null,
};

export const supportCenterWsocket = {
  io: false,
};